import React, { useEffect, useState } from 'react'
import "./testimonials.css"
import { Data } from "./Data.jsx"
import { FaStar, FaRegCircleUser  } from "react-icons/fa6";
import image from "../../assets/painter-for-footer.png"
import SingleBlob from '../blob/singleblob';


//Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react'

//Import Swiper Styles
import "swiper/css";
import "swiper/css/pagination";
import 'swiper/css/autoplay'; // Asegúrate de importar el CSS para autoplay

//Import required modules
import { Pagination, Autoplay } from 'swiper/modules';

import axios from 'axios';

const Testimonials = () => {
  

  const [reviews, setReviews] = useState([]);

  const MAX_CHARACTERS = 150; // Define el número máximo de caracteres

  const getTestimonials = async () => {
    try {
      // Realiza una solicitud GET a la API de Google Places
      const response = await axios.get('/maps/api/place/details/json', {
        params: {
          place_id: 'ChIJF4VAEObbvIYRwkRHj-yPKRw', // Sustituye con el ID real del lugar
          fields: 'review',
          key: 'AIzaSyCYu8XNMjiB5wdkdpsriEhTgn4DDmHSM_k' // Sustituye con tu clave API real
        }
      });
  
      // Envía las reseñas como respuesta en formato JSON
      if (response) {
        setReviews(response.data.result.reviews.map(review => ({
          ...review,
          truncatedText: review.text.length > MAX_CHARACTERS
            ? review.text.substring(0, MAX_CHARACTERS) + '...'
            : review.text
        })));
      } else {
        console.log('No se encontraron reseñas');
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
   getTestimonials()
  }, []);

  return (
   <section className="testimonials  section" id="testimonials">
     <h2 className="section__title testimonial__title">
     <i class="uil uil-star testimonial__title__icon"></i>
      Clients Reviews</h2>
     <span className="section__subtitle">What Our Clients Say</span>

     <Swiper className="testimonial__container"
     loop={true}
     grabCursor={true}
     spaceBetween={24}
     pagination={{
      clickable:true, 
     }}
     autoplay={{
      delay: 2000, // Tiempo en milisegundos antes de cambiar al siguiente slide
      disableOnInteraction: false // Continuar con autoplay después de que el usuario interactúe con el swiper
      }}
     breakpoints={{
      992: {
        slidesPerView:3,
      },
      576: {
        slidesPerView:1,
      },
      760:{
        slidesPerView:1,
        spaceBetween:40,
      },
   
     }}
     modules={[Pagination, Autoplay]}
     >
        {reviews.length > 0 ? reviews.map((review, index) => (
          <SwiperSlide className='testimonial__card' key={index}>
            <div style={{display: 'flex'}}>
            <FaStar className='rating__star'/>
              <p className="testimonial__description">{review.rating}/5</p>
            </div>
            <div className="testimonial__description__div">
            <p className="testimonial__description__text">"{review.truncatedText}"</p>
            </div>
            <div className="testimonial__user__and__icon">
              <FaRegCircleUser className='testimonial__user__icon'/>
              <h3 className="testimonial__name">{review.author_name}</h3>
            </div>
          </SwiperSlide>
        )) : <p>No reviews available</p>}
     </Swiper>
     <div className='testimonials__img__div'>
          <SingleBlob idgradiente="1" color="rgba(132, 21, 255, 0.80)" color2="rgba(132, 21, 255, 0.80)"/>
            <img src={image} alt="" className="testimonials__img" />
         </div>
   </section>
  )
}

export default Testimonials
